export class Contact {

    constructor(
        public name: string,
        public email: string,
        public phone: string,
        public message: string
    ) {  }

}